import React, { useEffect, useState } from "react";
import { Receipt, Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

/** مفتاح الأدمن لضريبة القيمة المضافة 15%: عند التفعيل تُضاف فوق الأسعار الصافية في كل دفع جديد وتصدر الفواتير ضريبية تلقائيًا */
export const VatSettingsCard = () => {
  const [cfg, setCfg] = useState(null);
  const [num, setNum] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/vat").then((r) => { setCfg(r.data); setNum(r.data.vat_number || ""); }).catch(() => {});
  useEffect(() => { load(); }, []);
  const save = async (enabled) => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/vat", { enabled, vat_number: num });
      setCfg(data);
      toast.success(enabled ? "تم تفعيل ضريبة القيمة المضافة 15% — تُطبَّق على كل عملية دفع جديدة وتصدر الفواتير ضريبية" : "تم إيقاف الضريبة — الأسعار نهائية بلا ضريبة");
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  if (!cfg) return null;
  return (
    <div className="glass rounded-2xl p-5 border border-border space-y-3" data-testid="vat-settings">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2"><Receipt className="w-5 h-5 text-accent" /><h2 className="font-bold">ضريبة القيمة المضافة (15%)</h2>
          <span className={`text-[11px] rounded-full px-2 py-0.5 ${cfg.enabled ? "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400" : "bg-secondary text-muted-foreground"}`} data-testid="vat-status">{cfg.enabled ? "مفعّلة" : "غير مفعّلة"}</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-xs text-muted-foreground">{cfg.enabled ? "إيقاف" : "تفعيل"}</span>
          <Switch checked={cfg.enabled} disabled={busy} onCheckedChange={(v) => save(v)} data-testid="vat-toggle" />
        </div>
      </div>
      <div className="grid sm:grid-cols-[1fr_auto] gap-2 items-end">
        <div>
          <label className="text-xs text-muted-foreground block mb-1">الرقم الضريبي للمنشأة (15 رقمًا) — يظهر على الفواتير الضريبية</label>
          <Input value={num} onChange={(e) => setNum(e.target.value.replace(/\D/g, "").slice(0, 15))} placeholder="3xxxxxxxxxxxxx3" dir="ltr" inputMode="numeric" className="bg-secondary border-border" data-testid="vat-number-input" />
        </div>
        <Button size="sm" variant="outline" disabled={busy || num === (cfg.vat_number || "")} onClick={() => save(cfg.enabled)} className="border-border" data-testid="vat-number-save">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "حفظ الرقم"}</Button>
      </div>
      <p className="text-[11px] text-muted-foreground leading-relaxed flex gap-1.5" data-testid="vat-note"><ShieldCheck className="w-3.5 h-3.5 text-primary shrink-0 mt-0.5" />
        {cfg.note} {cfg.activated_at && cfg.enabled && <>· فُعّلت في {cfg.activated_at.slice(0, 10)}</>}
        <br />الأسعار المعلنة تبقى صافية؛ عند التفعيل يُضاف 15% في نافذة الدفع وبوابة الدفع، وتُصدر الفواتير الجديدة كـ«فاتورة ضريبية» ببنود الإجمالي قبل الضريبة والضريبة. الفواتير السابقة لا تتغير.
      </p>
    </div>
  );
};
